(function () {
    'use strict';

    angular
        .module('rms.common')
        .constant('SELECT_CONSTANT', {
            'NONE': 0,
            'SOME': 1,
            'ALL':2,
            'SELECTED': 10,
            'NOT_SELECTED': 11
        });
})();